import { render, staticRenderFns } from "./BundleDataLayout1.vue?vue&type=template&id=4234b236&"
import script from "./BundleDataLayout1.vue?vue&type=script&lang=js&"
export * from "./BundleDataLayout1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports